<template>
  <div>
    <div v-if="isLoading">
      <PleaseWait :bgColour="'#FFFFFF'" />
    </div>
    <div v-if="mediaCount <= 0 && !isLoading" class="w-100 m-auto text-center">
      <!--      <NoContributed></NoContributed>-->
      <h4 class="text-inherit">No available media</h4>
      <p>Upload some media to get started.</p>
      <div class="upload-new-btn m-3 mx-5 p-4" @click="showUploadPage">
        Go to Media Upload
      </div>
    </div>
    <div v-else>
      <div class="grid">
        <div
          v-for="media in attachableMedia"
          v-bind:key="media.id"
          @click="onClick(media)"
        >
          <MediaMiniTile :media="media" />
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div
          v-if="mediaCount > 0"
          class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
        >
          <template>
            <paginate
              v-model="page"
              :page-count="pageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaService from "@/services/media.service";
import Paginate from "@/components/Paginate";
import MediaObject from "@/objects/MediaObject";
import NoContributed from "@/components/NoContributed";
import PleaseWait from "@/components/PleaseWait";
import MediaMiniTile from "@/components/MediaMiniTile";

export default {
  name: "MediaLibrary",
  components: {
    Paginate,
    NoContributed,
    PleaseWait,
    MediaMiniTile,
  },
  data: function () {
    return {
      isLoading: true,
      NUMBER_TO_GET: 9,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      media: [],
      pageNum: 0,
      mediaObjects: [],
      isActive: false,
    };
  },
  computed: {
    attachableMedia() {
      const alreadyAttached = this.$store.state.createForumPostStore
        .mediaToAttach;

      return this.mediaObjects.filter(
        (allMedia) =>
          !alreadyAttached.find((attached) => attached.id === allMedia.id)
      );
    },
    mediaCount() {
      return this.attachableMedia.length;
    },
  },
  methods: {
    getMedia(startAt) {
      this.isLoading = true;
      this.isActive = true;
      MediaService.myUnpostedMedia(startAt, this.NUMBER_TO_GET).then((data) => {
        this.mediaObjects = data.media
          .map((media) => new MediaObject(media));

        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });

      this.isActive = false;
    },

    clickCallback: function (pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.mediaObjects = [];

      this.getMedia(this.NUMBER_TO_GET * pageNum);
    },
    updatePageCount() {
      this.pageCount = Math.ceil(this.mediaCount / this.NUMBER_TO_GET);
    },
    onClick(media) {
      this.$emit("on-click", media);
    },
    showUploadPage() {
      this.$router.push({ name: "media-upload" });
    },
  },

  beforeMount() {
    this.isLoading = true;
    this.getMedia();
  },
};
</script>

<style scoped>
.grid {
  display: flex;
  flex-wrap: wrap;
}

.upload-new-btn {
  background: var(--isim-primary-light);
  color: var(--isim-secondary);
  border-radius: 8px;
  cursor: pointer;
}
</style>
